/** 空间根节点 id：选中时展示空间全部人员 */
export const SPACE_ROOT_ID = 'space-root';

/** 左侧组织树与列表联动使用的选中节点 */
export interface ContactsOrgNode {
  id: string;
  name: string;
  /** 非空间根时对应通讯录接口返回的组织对象 */
  rawOrg?: Record<string, unknown> | null;
  isSpaceRoot?: boolean;
}
